'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Phone;
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function Phone(_ref) {
  var size = _ref.size,
    strokeColor = _ref.strokeColor,
    strokeWidth = _ref.strokeWidth,
    fillColor = _ref.fillColor,
    svgClass = _ref.svgClass;
  var inlineStyling = {
    fill: fillColor,
    stroke: strokeColor,
    strokeWidth: strokeWidth
  };
  return _react2.default.createElement('svg', {
    className: svgClass,
    height: size,
    style: inlineStyling,
    viewBox: '0 0 24 24',
    width: size,
    xmlns: 'http://www.w3.org/2000/svg'
  }, _react2.default.createElement('path', {
    d: 'M7.21777778,10.9244444 C8.49777778,13.44 10.56,15.5022222 13.0755556,16.7822222 L15.0311111,14.8266667 C15.28,14.5777778 15.6266667,14.5066667 15.9377778,14.6044444 C16.9333333,14.9333333 18,15.1111111 19.1111111,15.1111111 C19.6020309,15.1111111 20,15.5090802 20,16 L20,19.1111111 C20,19.6020309 19.6020309,20 19.1111111,20 C10.7654749,20 4,13.2345251 4,4.88888889 C4,4.6531409 4.09365052,4.42704853 4.26034953,4.26034953 C4.42704853,4.09365052 4.6531409,4 4.88888889,4 L8,4 C8.49091978,4 8.88888889,4.39796911 8.88888889,4.88888889 C8.88888889,6 9.06666667,7.06666667 9.39555556,8.06222222 C9.49333333,8.37333333 9.42222222,8.72 9.17333333,8.96888889 L7.21777778,10.9244444 Z'
  }));
}
Phone.defaultProps = {
  strokeColor: 'blue',
  strokeWidth: 0,
  fillColor: '#bada55',
  size: 32,
  svgClass: 'sui-SVGicon'
};